import "./NewDataset.less"
import Images from "../../utils/Images";
import { useState, useRef, useEffect } from "react";
import { Select, Input } from "antd";
import { SliderWithInput } from "../../component/SliderWithInput/SliderWithInput";
import CustomButton from "../../component/CustomButton/CustomButton";
import { MyDataset } from "../../component/MyDataset/MyDataset";
import { needLogin } from "../../utils/decor";
import { inject, observer } from "mobx-react";
import { AdvanceSetting } from "../../component/AdvanceSetting/AdvanceSetting";
import { msgbox, MSG_TYPE } from "../../utils/Msgbox";
import { TrainModelParam } from "../../model/TrainModelParam";
import { TASK_STATUS, TrainInfo, TrainInfoModel } from "../../store/TrainManageStore";
import getStoreFromProps from "../../store/getStoreFromProps";

const modelTheme: string[][] = [
    [Images.modelTheme0, "XL"],
    [Images.modelTheme1, "动漫"],
    [Images.modelTheme2, "人像"],
    [Images.modelTheme3, "画风"],
];

const BOTTOM_DIR_OPTIONS: any[][] = [
    [
        {label: "风格化-SDXL基础模型", value: "SDXL_BASE"}
    ],
    [
        {label: "动漫", value: "ANIM"},
        {label: "蓝色铅笔", value: "BLUE_PENCIL"},
    ],
    [
        {label: "写实人物", value: "REALISTIC_CHARACTER"},
    ],
    [
        {label: "风格化-SDXL基础模型", value: "SDXL_BASE"},
    ]
];

const MAX_MODEL_NAME_LEN: number = 12;

type ParameterSettingProps = {
    onAdvanceSettingClick: () => void;
};

const ParameterSetting = inject("dataset", "advanceSetting", "trainManage")(observer((props:ParameterSettingProps): React.ReactElement => {
    const [modelThemeIndex, setModelThemeIndex] = useState(0);
    const [bottomDie, setBottomDie] = useState(BOTTOM_DIR_OPTIONS[0][0].value);
    const selfRef = useRef<HTMLDivElement>(null);
    const datasetStore = getStoreFromProps(props, "dataset");
    const advanseSettingStore = getStoreFromProps(props, "advanceSetting");
    const trainManageStore =  getStoreFromProps(props, "trainManage");
    const [lastTotalStep, setLastTotalStep] = useState(0);

    const startTrain = needLogin((): void => {
        if(!datasetStore.curDatasetInfo){
            msgbox("请选择数据集", MSG_TYPE.ERROR);
            return;
        }

        if(datasetStore.curDatasetInfo.imgs.length < 2){
            msgbox("数据集需要至少2张图片", MSG_TYPE.ERROR);
            return;
        }

        if(datasetStore.curDatasetInfo.imgs.some(item => item.text.length <= 0)){
            msgbox("数据集未裁剪/打标", MSG_TYPE.ERROR);
            return;
        }

        if(advanseSettingStore.prompt.length <= 0){
            msgbox("模型效果预览提示词不能为空", MSG_TYPE.ERROR);
            return;
        }
        
        const param = new TrainModelParam();
        param.name = advanseSettingStore.modelName;
        param.datasetId = datasetStore.curDatasetInfo!.id;
        param.baseModel = bottomDie;
        param.repeat = advanseSettingStore.repeat;
        param.epoch = advanseSettingStore.epoch;
        param.batchSize = advanseSettingStore.batchSize;
        param.samplerPrompt = advanseSettingStore.prompt;
        param.width = advanseSettingStore.resolution[0];
        param.height = advanseSettingStore.resolution[1];
        param.samplerSeed = advanseSettingStore.seed;
        param.sampler = advanseSettingStore.sampler;
        param.saveEveryEpoch = advanseSettingStore.saveEveryNEpochs;
        param.savePrecision = advanseSettingStore.savePrecision;
        param.learningRate = Number(advanseSettingStore.learningRate);
        param.unetLr = advanseSettingStore.unetlr;
        param.textEncoderLr = advanseSettingStore.textEncoderLr;
        param.lrWarmup = advanseSettingStore.lrWarmUp;
        param.lrScheduler = advanseSettingStore.lrScheduler;
        param.optimizer = advanseSettingStore.optimizer;
        param.lrSchedulerNumCycles = advanseSettingStore.lrSchedulerNumCycles;
        param.trainUnetOnly = advanseSettingStore.trainUnetOnly;
        param.trainTextEncoderOnly = advanseSettingStore.trainTextEncoderOnly;
        param.minSnrGamma = advanseSettingStore.minSnrGamma;
        param.noiseOffset = advanseSettingStore.noiseOffset;
        param.seed = advanseSettingStore.advanceSeed;
        param.clipSkip = advanseSettingStore.clipSkip;
        param.networkAlpha = advanseSettingStore.networkAlpha;
        param.networkRankDim = advanseSettingStore.networkRankDim;

        const step = totalStep();
        setLastTotalStep(step);
        localStorage.setItem("lastTotalStep", String(step));

        trainManageStore.totalTime = step * 3;
        trainManageStore.startTrain(param)
            .then(() => {
                msgbox("训练成功，点击训练管理查看结果", MSG_TYPE.SUCCESS);
            })
            .catch(reason => msgbox(reason.message, MSG_TYPE.ERROR));
    });

    const stopTrain = (): void => {
        //datasetStore.stopTrain();
    };

    const init = (): void => {
        const step = Number(localStorage.getItem("lastTotalStep") || "0");
        setLastTotalStep(step);
        trainManageStore.totalTime = step * 3;
    };

    useEffect(init, []);

    const trainBtn = (): React.ReactElement => {
        return <CustomButton className="new-dataset-parameter-setting-start-train" onClick={startTrain}>
            <div className="new-dataset-parameter-setting-start-train-title">
                <span>开始训练</span>
            </div>
        </CustomButton>;
    };

    const totalStep = (): number => {
        if(!datasetStore.curDatasetInfo || datasetStore.curDatasetInfo.imgs.length <= 0){
            return -1;
        }
        return advanseSettingStore.repeat * advanseSettingStore.epoch * datasetStore.curDatasetInfo.imgs.length;
    };

    const totalStepStr = (a: number): string => {
        if(a <= 0){
            return "总步数：上传图片后计算";
        }
        return `总步数: ${a} 预计训练时间${formatTime(a * 3)} 0-6点错峰训练更快哦`;
    };

    const onThemeBtnClick = (index: number): void => {
        setModelThemeIndex(index);
        setBottomDie(BOTTOM_DIR_OPTIONS[index][0].value);
    };

    const stopBtn = (title: string): React.ReactElement => {
        return <div className="new-dataset-parameter-setting-stop-btn">{title}</div>;
    };

    const onModelNameChange = (a: string): void => {
        advanseSettingStore.modelName = a;
    };

    const progressHint = (taskStatus: TASK_STATUS): string => {
        switch(taskStatus){
            case TASK_STATUS.WAITING:
                return "等待中";
            case TASK_STATUS.PROCESSING:
                return "训练中";
            default:
                return "";
        }
    }

    const formatTime = (a: number): string => {
        return `${String(Math.floor(a / 3600)).padStart(2, "0")}:${String(Math.floor((a % 3600) /  60)).padStart(2, "0")}:${String((a % 60)).padStart(2, "0")}`;
    };

    const step = totalStep();
    const progress = trainManageStore.progress;
    const isTraining = trainManageStore.status > TASK_STATUS.NONE && trainManageStore.status < TASK_STATUS.SUCCESS;
    return <div className="new-dataset-parameter-setting" ref={selfRef}>
        <div className="new-dataset-parameter-setting-title-wrap">
            <span>参数设置</span>
            <img src={Images.gear} onClick={props.onAdvanceSettingClick}></img>
            <span onClick={props.onAdvanceSettingClick}>专业参数</span>
        </div>
        <div className="new-dataset-parameter-setting-content-wrap no-scrollbar">
            <div className="new-dataset-parameter-setting-title-1">模型主题</div>
            <div className="new-dataset-parameter-setting-model-theme-wrap">
                {modelTheme.map((item, i) =>
                    <div key={i} data-select={modelThemeIndex === i} className="new-dataset-parameter-setting-model-theme-item" style={{"--img": `url(${item[0]})`} as React.CSSProperties}
                        onClick={() => onThemeBtnClick(i)}>
                        <span>{item[1]}</span>
                    </div>)}
            </div>
            <div className="new-dataset-parameter-setting-title-5">使用底模</div>
            <div className="new-data-set-parameter-setting-select new-data-set-parameter-setting-bottom-die">
                <Select options={BOTTOM_DIR_OPTIONS[modelThemeIndex]} getPopupContainer={t => selfRef.current as HTMLDivElement} value={bottomDie} onChange={a => setBottomDie(a)} popupClassName="new-data-set-parameter-setting-select-popup"></Select>
            </div>
            <div className="new-dataset-parameter-setting-title-2">单张次数  Repeat</div>
            <SliderWithInput value={advanseSettingStore.repeat} onChange={a => advanseSettingStore.repeat = a} min={1} max={50}></SliderWithInput>
            <div className="new-dataset-parameter-setting-title-3">训练轮数  Epoch</div>
            <SliderWithInput value={advanseSettingStore.epoch} onChange={a => advanseSettingStore.epoch = a} min={1} max={20}></SliderWithInput>
            <div className="new-dataset-parameter-setting-total-step">{totalStepStr(step)}</div>
            <div className="new-dataset-parameter-setting-title-5">模型名称</div>
            <div className="new-dataset-parameter-model-name-input-frame">
                <Input variant="borderless" value={advanseSettingStore.modelName} onChange={e => onModelNameChange(e.target.value)} placeholder="请输入训练生成的模型名称" maxLength={MAX_MODEL_NAME_LEN}></Input>
                <span>{advanseSettingStore.modelName.length}/{MAX_MODEL_NAME_LEN}</span>
            </div>
            <div className="new-dataset-parameter-setting-title-4">
                <span>模型效果预览提示词</span>
                <span>训练中会根据提示词生成实时样图</span>
            </div>
            <div className="new-dataset-parameter-setting-prompt">
                <Input.TextArea variant="borderless" style={{resize:"none"}} value={advanseSettingStore.prompt} onChange={e => advanseSettingStore.prompt = e.target.value} placeholder="可输入打标内容"></Input.TextArea>
            </div>
        </div>
        <div className="new-dataset-parameter-settings-bottom-wrap">
            {isTraining && <>
                <div className="new-dataset-parameter-train-hint">
                    <span>步数({Math.floor(progress * lastTotalStep)}/{lastTotalStep}({Math.floor(progress * 100)}%))</span>
                    <span>时间({formatTime(trainManageStore.timeElapsed)}/{formatTime(trainManageStore.totalTime)})</span>
                </div>
                <div className="new-dataset-parameter-train-progress-bar" style={{"--progress": `${progress * 100}%`} as React.CSSProperties}>
                    <div></div>
                </div>
                {stopBtn(progressHint(trainManageStore.status))}
            </>}
            {!isTraining && trainBtn()}
        </div>
    </div>;
}));

export const NewDataset = (): React.ReactElement => {
    const [isAdvanceSettingVisible, setIsAdvanceSettingVisible] = useState(false);

    return <div className="new-dataset">
        <ParameterSetting onAdvanceSettingClick={(() => setIsAdvanceSettingVisible(true))}></ParameterSetting>
        <MyDataset></MyDataset>
        {isAdvanceSettingVisible && <AdvanceSetting onClose={() => setIsAdvanceSettingVisible(false)}></AdvanceSetting>}
    </div>;
};